import {
    Divider,
    BreadcrumbLink,
    VStack,
    Box,
    Grid,
    GridItem,
    Text,
    Button,
    HStack,
} from '@chakra-ui/react';
import { ChatCreateViewProps } from './chatCreateProps';
import React from 'react';
import { ReportingShellViewBaseConfig } from '../../../base';
import { ChatDetailContainerProps } from '../detail';
import { ChatComposerContainerProps } from '../common';

export function createChatCreateView(
    config: ReportingShellViewBaseConfig & {
        Container: {
            Composer: React.FC<ChatComposerContainerProps>;
        };
    }
): React.FC<ChatCreateViewProps> {
    const {
        UI: {
            Application: { Anchor, Link },
        },
        Container: { Composer: ComposerContainer },
    } = config;

    return (props) => {
        return (
            <Grid w="full" h="full" templateRows="1fr min-content">
                <GridItem
                    as={HStack}
                    justify="center"
                    w="full"
                    pb={{ base: 12, xl: 24 }}
                    px={{ base: 2, xl: 3 }}
                >
                    {props.history && (
                        <VStack align="start" spacing={2} w="full" maxW="20rem">
                            <Text fontWeight="medium" color="whiteAlpha.500">
                                {props.history.label}
                            </Text>
                            <VStack align="start" spacing={0} w="full">
                                {props.history.items.map((item) => (
                                    <Button
                                        key={item.id}
                                        {...item.button}
                                        py={1.5}
                                        px={3}
                                        w="full"
                                        variant="link"
                                        size="sm"
                                        color="whiteAlpha.600"
                                        bg="none"
                                        fontWeight="normal"
                                        _hover={{
                                            bg: 'whiteAlpha.50',
                                        }}
                                    >
                                        <HStack
                                            w="full"
                                            justify="space-between"
                                            spacing={6}
                                        >
                                            <Text
                                                color="whiteAlpha.800"
                                                noOfLines={1}
                                                fontWeight="medium"
                                            >
                                                {item.label}
                                            </Text>
                                            <Text color="whiteAlpha.400" fontSize="xs">
                                                {item.timestamp.relative}
                                            </Text>
                                        </HStack>
                                    </Button>
                                ))}
                            </VStack>
                        </VStack>
                    )}
                </GridItem>
                <GridItem as={VStack} px={3} pb={8} align="start" spacing={2}>
                    <ComposerContainer {...props.composer} />
                </GridItem>
            </Grid>
        );
    };
}
